"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinishLayer = void 0;
const FixRatioContainer_1 = require("../Common/FixRatioContainer");
const Constants_1 = require("../Core/Constants");
const inversify_1 = require("inversify");
const GameState_1 = require("../Core/GameState");
const InfoType_1 = require("../Common/InfoObject/InfoType");
const pixi_js_1 = require("pixi.js");
const SymbolClasses_1 = require("../Utils/SymbolClasses");
const InfoSprite_1 = require("../Common/InfoObject/InfoSprite");
const GameConfig_1 = require("../Core/GameConfig");
const InfoNumberSprite_1 = require("../Common/InfoObject/InfoNumberSprite");
const AutoPlayLayer_1 = require("./Sublayers/AutoPlayLayer");
let FinishLayer = class FinishLayer extends FixRatioContainer_1.FixRatioContainer {
    constructor(state, events, resources, loadcfg, ioc, config) {
        super(Constants_1.LayerWidth, Constants_1.LayerHeight);
        this.onRetry = () => {
            /** */
        };
        this.onBack = () => {
            /** */
        };
        this.resize(...events.Resize.prevArgs);
        events.Resize.add((remove, w, h) => {
            if (!this.parent)
                return remove();
            this.resize(w, h);
        });
        const info = resources.ui.data.info.score;
        const textures = resources.ui.textures;
        if (info.other instanceof Array) {
            for (const x of info.other) {
                this.addChild(new InfoSprite_1.InfoSprite(x, textures));
            }
        }
        const numbers = ["perfect", "great", "good", "bad", "miss", "score", "combo"];
        numbers.forEach(x => {
            const n = new InfoNumberSprite_1.InfoNumberSprite(info[x], textures);
            if (x === "combo")
                n.setValue(state.maxCombo);
            else
                n.setValue(state[x]);
            this.addChild(n);
        });
        if (state.maxCombo === state.map.combo) {
            this.addChild(new InfoSprite_1.InfoSprite(info.fullcombo, textures));
        }
        if (info.name) {
            const name = new pixi_js_1.Text(loadcfg.songName, info.name.style);
            InfoType_1.setPositionInfo(name, info.name.position);
            this.addChild(name);
        }
        const retry = new InfoSprite_1.InfoSprite(info.retry, textures);
        const back = new InfoSprite_1.InfoSprite(info.back, textures);
        retry.interactive = true;
        //        retry.buttonMode = true
        back.interactive = true;
        //        back.buttonMode = true
        retry.once("pointertap", () => {
            this.onRetry();
        });
        back.once("pointertap", () => {
            this.onBack();
        });
        this.addChild(retry, back);
        events.Update.add((remove, dt) => {
            if (!this.parent)
                return remove();
            for (const x of this.children) {
                if (x instanceof InfoSprite_1.InfoSprite || x instanceof InfoNumberSprite_1.InfoNumberSprite) {
                    x.update(dt);
                }
            }
        });
        if (config.autoplay) {
            this.addChild(ioc.resolve(AutoPlayLayer_1.AutoPlayLayer));
        }
    }
};
FinishLayer = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [GameState_1.GameState,
        SymbolClasses_1.GlobalEvents,
        SymbolClasses_1.Resources,
        GameConfig_1.GameLoadConfig,
        inversify_1.Container,
        GameConfig_1.GameConfig])
], FinishLayer);
exports.FinishLayer = FinishLayer;
//# sourceMappingURL=FinishLayer.js.map